import {FPNetDate} from "@commons/types";
import {TabellaDominioBase} from "@commons/mapping/TabellaDominioBase";

/**
 * Tabella proprietà generali di Workflow
 * N.B. descrizione // max 40 caratteri
 */
export interface TabellaWFRecord extends TabellaDominioBase {
    sendNotification: boolean,
    sendRiepilogo: boolean,
    sendReminder: boolean,
    sendProcessed: boolean,
    showRiepilogoFR: boolean,
    showOrePreviste: boolean,
    showOreLavorate: boolean,
    showTimbrature: boolean,
    calcolaPresenze: boolean,
    calcolaFinoAl: number,
    decorrenza: FPNetDate, // es. "2022-01-01"
    fineValidita: FPNetDate, // es. "2022-01-01"
    idTipoTabella: number | null, // Idetntifica la tabella azienda per la quale raccogliere i valori in MonitorWF e DashboardWF per filtrare i lavoratori
    descrizioneTipo: string,
}

export class TabellaWFRecord {
    static showOptions = (that: TabellaWFRecord | undefined) => {
        return that && that.idTabella !== 13;
    };
}